import { Fancybox } from "@fancyapps/ui";

Fancybox.defaults.Hash = false;
Fancybox.defaults.dragToClose = false;

// Fancybox.bind("[data-fancybox]", {
//   // Your options go here
// });
